import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { miscellaneousApi } from '../api/miscellaneousApi'; 
import { RootState } from '..';

export interface MiscellaneousState {
  miscellaneousDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: MiscellaneousState = {
  miscellaneousDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const miscellaneousSlice = createSlice({
  name: 'miscellaneous',
  initialState,
  reducers: {
    setMiscellaneousDetails: (state, action: PayloadAction<any>) => {
      state.miscellaneousDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        miscellaneousApi.endpoints.saveMiscellaneousCharge.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        miscellaneousApi.endpoints.saveMiscellaneousCharge.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.miscellaneousDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        miscellaneousApi.endpoints.saveMiscellaneousCharge.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setMiscellaneousDetails, setLoading, setError, reset } =  miscellaneousSlice.actions;
export const getMiscellaneousDetails = (state: RootState) => state.miscellaneous.data;
export const getMiscellaneousTotalRecords = (state: RootState) => state.miscellaneous.totalRecords;

export default miscellaneousSlice.reducer;